module.exports = __webpack_public_path__ + "assets/img/loading.5165c64d.gif";